<template>
<div>

<div role="alert" class="alert alert-danger alert-dismissible fade show top-alert text-center border-0 mb-0">
    <span class="mr-3 top-icon"><i class="fas fa-video text-white video-icon pt-2"></i></span>
    <span class="top-alert-message">
    <marquee width="80%" direction="left" behavior="scroll" scrollamount="5" onmouseover="this.stop();" onmouseout="this.start();">We are offering Home pickup &amp; drop service.<strong>Know more</strong></marquee></span>
    <button type="button" data-dismiss="alert" aria-label="Close" class="close cAnnoucementclose"><i class="far fa-times-circle"></i></button>
</div>

    <div class="row top-info" >
    <div class="col-md-6 col-10 pr-0 top-head align-self-center">
        <div class="input-group cCurrentlocation">
            <div class="input-group-prepend">
                <span class="input-group-text address-background border-0"><img src="./assets/img/newchanges/Vector (1).svg" class="img-fluid" alt="Responsive image"></span>
            </div>

            <span @click="geolocate()" class="option-font-size cCursorhover custom-text-color address-background">{{formattedAddress | locLength}} </span>  
           
        </div>
    </div>

    <div class="col-md-3 col-2 text-right pl-0 align-self-center homepage-for-desktop" >
        <div class="dropdown">
            <button  class="btn top-button bg-white" type="button" id="dropdownMenuButton"  aria-haspopup="true" aria-expanded="false">
                <i  class="fas rounded-circle mr-2" height="28px" width="28px"></i><span class="user-name"></span>
            </button>
            
        </div>
    </div>

    <div data-toggle="modal" data-target="#login-phone" id="loginBtn" class="col-md-3 col-2 text-right pl-0 align-self-center homepage-for-desktop" v-if="!loginBoolean">
        <div class="dropdown">
            <button  class="btn top-button bg-white" type="button" id="dropdownMenuButton"  aria-haspopup="true" aria-expanded="false">
                <i  class="fas fa-user-circle img-fluid rounded-circle mr-2" height="28px" width="28px"></i><span class="user-name">Login</span>
            </button>
            
        </div>
    </div>

    <div class="col-md-3 col-2 text-right pl-0 align-self-center homepage-for-desktop" v-if="loginBoolean">
        <div class="dropdown">
            <button class="btn top-button bg-white dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img v-if="userImage != '' && userImage != null" v-bind:src="userImage" class="rounded-circle user-image mr-2" height="35px" width="35px" alt="User image">
                <i v-if="userImage == '' || userImage==null" class="fas fa-user-circle img-fluid rounded-circle mr-2" height="35px" width="35px"></i>
                <span class="user-name">{{citizenName}}</span>
            </button>
            <div class="dropdown-menu dropdown-menu-tags" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item cCursorhover" @click="logout()">Logout</a>
                <a class="dropdown-item cCursorhover" @click="openUserProfile()">My Profile</a>
            </div>
        </div>
    </div>

    <div data-toggle="modal" data-target="#login-phone" id="loginBtn" class="col-md-3 col-2 text-right pl-0 align-self-center for-mobile" v-if="!loginBoolean">
        <div class="dropdown">
            <button type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn top-button bg-white">
                <i class="fas rounded-circle mr-2" height="28px" width="28px"></i>
            </button>
        </div>
    </div>

    
    <div class="col-md-3 col-2 text-right pl-0 align-self-center for-mobile" v-if="loginBoolean">
        <div class="dropdown">
            <button type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn top-button bg-white">
                 <img v-if="userImage != '' && userImage != null" v-bind:src="userImage" class="rounded-circle user-image mr-2" height="35px" width="35px" alt="User image">
                <i v-if="userImage == '' || userImage==null" class="fas fa-user-circle img-fluid rounded-circle mr-2" height="35px" width="35px"></i>
            </button>
             <div class="dropdown-menu dropdown-menu-tags" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item cCursorhover" @click="logout()">Logout</a>
                <a class="dropdown-item cCursorhover" @click="openUserProfile()">My Profile</a>
            </div>
        </div>
        
    </div>
</div>


<div class="modal fade login show" id="login-phone" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Login or Sign Up</h5>
                <button type="button" class="close" id="phoneLogin" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="./assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pr-4 pl-4 pb-4">
                <form class=" pb-4">
                    <div class="form-group">
                        <label class="col-form-label continue-color"><b>Phone Number</b></label>
                        <div class="input-group mb-2 text-muted">
                             <div class="input-group-prepend">
                                            <div class="input-group-text prepend-background border-right-0 p-0">
                                                <select @change="getCountryDetails($event)" class="form-control custom-select number-code-text prepend-background border-0" id="inputGroupSelect01">
                                                    <option v-for="country in countryList" :key="country.id" v-bind:value="country.CountryCode">{{country.CountryCode}}</option>
                                                </select>
                                            </div>
                            </div>
                            <input type="number" v-on:keyup="validatePhone($event)" class="form-control prepend-background border-left-0 text-muted" maxlength="10" id="contact" name="contact" placeholder="Enter phone number" />
                        </div>
                        <div class="errorMessage">
                            {{phoneErrorMessage}}
                        </div>
                    </div>
                    <div class="form-group">
                        <a data-toggle="modal" data-target="#enter-otp" data-whatever="@mdo"><button type="submit" @click="submitOtp()" class="btn btn-block create-account text-white bgBlue">Send OTP</button></a>
                    </div>
                </form>
                <div class="row">
                    <div class="col-md-12">
                        <b class="continue-color other-sign-font">Other Sign In Options</b>
                    </div>
                </div>
                <div class="google-sign mt-4 pl-4 pr-4">
                    <a  class="text-dark cCursorhover"><img src="./assets/img/search.svg" height="29px" width="29px" class="img-fluid mr-2"><small><b class="other-sign-font">Sign In with Google</b></small></a>
                </div>
                
                
                    <div class="google-sign mt-3 pl-4 pr-4" data-toggle="modal"  data-dismiss="modal" data-target="#login-email">
                    <a class="text-dark cCursorhover"><img src="./assets/img/Group 175.svg" height="29px" width="29px" class="img-fluid mr-2"><small><b class="other-sign-font">Sign In with Email</b></small></a>
                    </div>
                   
                    <div class="google-sign mt-3 pl-4 pr-4" @click.prevent="loginWithFacebook">
                    <a class="text-dark cCursorhover"><img data-v-d78a55b6="" src="./assets/img/Icon_awesome-facebook.svg" height="29px" width="29px" class="img-fluid mr-2"><small ><b  class="other-sign-font">Sign In with Facebook</b></small></a>
                    </div>

                   
            </div>
        </div>
    </div>
</div>

<div v-if="verifyOtpBoolean" class="modal fade login show" id="enter-otp" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Enter OTP</h5>
                <button type="button" class="close" id="otpClose" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><img src="./assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12 pb-3">
                        <small class="otp-heading"><b>Enter One Time Password, You received on {{countryCode}} {{userContactNo}}</b></small>
                    </div>
                </div>
                

                <div class="row">
                    <div id="divOuter" v-on:keyup="validateOtp()"  class="otp-group"><div id="divInner"><input id="otp-1" class="cOTPInput" placeholder="Enter OTP"  type="number" maxlength="4"></div></div>
                </div>

                <div class="errorMessage">
                            {{OtpErrorMessage}}
                        </div>
                <div class="row pt-3">
                    <div class="col-md-12 anchor-tag-text pb-4 text-right">
                        <a  @click="submitOtp()" v-if="!resend">
                            <small @click="resendOtp()" class="cResendotp cCursorhover"><b>Didn't receive the code? Resend OTP</b></small>
                            
                        </a>
                        <a v-if="resend">
                            <p class="mb-0" id="resend-otp-again"><small><b>Resend OTP in {{countdown}} Seconds</b></small></p>
                        </a>
                    </div>
                    <div class="col-md-12">
                        <button type="button" @click="verifyOtp()" id="verifyOtp"   class="btn btn-block create-account bgBlue"><a  class="text-white" >CONTINUE</a></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade login show"   id="login-name" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Login or Sign Up</h5>
                <button type="button" class="close" data-dismiss="modal" id="closeName" aria-label="Close">
                <span aria-hidden="true"><img src="./assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pr-4 pl-4 pb-4">
                <form @submit.prevent="onSubmit()">
                    <div class="form-group">
                        <label class="col-form-label continue-color"><b>Your Name</b></label>
                        <div class="input-group mb-2 text-muted">
                            <div class="input-group-prepend">
                                <div class="input-group-text prepend-background border-right-0"><img src="./assets/img/Icon awesome-user-alt.svg" class="img-fluid"></div>
                            </div>
                            <input type="text" v-on:keyup="validateName($event)" class="form-control prepend-background border-left-0 is-valid" id="username"  name="name" placeholder="Enter your name"/>
                            <!-- <div class="valid-feedback">
                                <img src="../assets/img/Icon awesome-check-circle.svg" class="img-fluid mr-2">Best name ever
                            </div> -->
                       
                        </div>
                    </div>
                     <div class="errorMessage">
                            {{NameErrorMessage}}
                        </div>
                    <div class="mt-4">
                        <a><button type="submit" @click="updateName()" class="btn btn-block create-account text-white bgBlue" >CREATE ACCOUNT</button></a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

  <div id="cWebApp" :key="componentKey">
    <router-view></router-view>
  </div>


<section class="cInstacitifooter">
        <div class="container" v-for="item in items" :key="item.id">

            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="footer-store-branding">
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <div class="footer-store-logo">
                                    <img v-bind:src="item[0].JSon0[0].LogoURL"
                                        alt="" class="img-fluid">
                                </div>
                            </div>
                            <div class="col-md-8 col-12 p-0">
                                <div class="footer-store-name">
                                    <h4>{{item[0].JSon0[0].CompanyName}} </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="footer-store-location">
                        <h5>Store Location</h5>
                        <p>{{item[0].JSon0[0].Address}}</p>
                    </div>
                    <div class="footer-store-contact">
                        <h5 class="pb-2">Contact Details</h5>
                        <div class="d-flex justify-content-between">
                            <button v-if="item[0].JSon2.length != 0" @click="call(item[0].JSon2[0].MobileNumber)" type="button" class="btn btn-outline-danger footer-btn footer-call"><i
                                    class="fas fa-phone-alt pr-2"></i>{{item[0].JSon2[0].MobileNumber}}</button>
                            <button @click="openWhatsapp(item[0].JSon2[0].MobileNumber)" type="button" class="btn btn-outline-danger footer-btn footer-whatsapp"><i
                                    class="fab fa-whatsapp pr-2"></i>WhatsApp</button>
                        </div>
                    </div>


                </div>

                <div class="col-lg-4 col-md-12">
                    <div class="footer-store-map">
                    <GmapMap
                    :center="center"
                    :zoom="18"
                    map-style-id="roadmap"
                    :options="mapOptions"
                    style="width: 350px; height: 300px"
                    ref="mapRef"
                    @click="handleMapClick"
                    >
                    <GmapMarker
                    :position="markerStore.position"
                    :clickable="true"
                    :draggable="true"
                    @drag="handleMarkerDrag"
                    @click="panToMarker"
                    />
                    </GmapMap>

                </div>
            </div>
            </div>

            <hr>

            <div class="row">
                <div class="col-md-6">
                    <div class="footer-store-poweredby">
                        <p>Powered by <a target="_blank"><img
                                    src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/instaciti-logo.png" alt=""
                                    class="img-fluid"></a></p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="footer-store-policy float-right">
                        <a @click="openTC()" class="cCursorhover">Terms & Conditions</a> |
                        <a @click="openRefund()" class="cCursorhover">Privacy Policy</a> |
                        <a @click="openReport()" class="cCursorhover">Report Issue</a>
                    </div>
                </div>
            </div>

       
        </div>
    </section>




</div>
</template>

<script>
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'


Vue.use(VueGoogleMaps,{
  load: {
    key: "AIzaSyCRNkCEhDvjxASZD11b_PRPZ45VVNdNQZ0",
    libraries:'places'
  },
});

export default {
  name: 'App',
  
   data : function(){
      return {
           marker: { position: { lat: 10, lng: 10 } },
           markerStore: { position: { lat: 10, lng: 10 } },
           formattedAddress : 'Select your current address',
           loginBoolean : false,
           citizenName : '',
           componentKey : 0,
           userImage : '',
           countryList : [],
           countryCode : '',
           phoneMaxLength : 10,
           portalContext : '',
           phoneErrorMessage : "",
           userContactNo : "",
           otpHandle : "",
           citizenHandle : "",
           verifyOtpBoolean : false,
           OtpErrorMessage : '',
           resend : false,
           countdown : 10,
           successfullLogin:false,
           NameErrorMessage : '',
           center: { lat: 10, lng: 10 },

          mapOptions: {
          disableDefaultUI: true,
          },
      }
  },
    computed:{
      items() {
        return this.$store.state.items
      }
    },
    filters: {
        locLength: function(string){
            if(string.length > 45){
                return string.substring(0,45) + '...'
            }
            return string
        },
    },
  mounted() {
      
      axios
                .get('https://entityserver.manikworks.com/apptoken',
              
                {
                    headers: {
                        'TenantID': 'INSTA.SERVICE'
                    }
                })
                .then((response) =>{
                console.log(response)
                sessionStorage.setItem('Token',response.data.ManikJSon[0].JSon0)

        axios
                .post('https://entityserver.manikworks.com/bookmgr',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'GET.STORE.OUTLETS',
                        'BusinessHandle': this.$route.params.handle,
                    }
                })
                .then((response) =>{
                   
                    
                    if(response.data.ManikJSon[0].JSon0.length == 1){
                        sessionStorage.setItem('ECommDS',response.data.ManikJSon[0].JSon0[0].ECommDS);
                        sessionStorage.setItem('handle',response.data.ManikJSon[0].JSon0[0].BranchHandle);
                        sessionStorage.removeItem('Scratchhandle')
                    }
                    else{
                        
                        sessionStorage.setItem('ECommDS',response.data.ManikJSon[0].JSon0[0].ECommDS);
                        sessionStorage.setItem('handle',response.data.ManikJSon[0].JSon0[0].BranchHandle);
                        sessionStorage.setItem('Scratchhandle',response.data.ManikJSon[0].JSon0[0].BranchHandle);
                    }

                   this.getCordinates();
                })
                })
                .catch(() =>{
                    this.isLoading = false;
                })


      if(localStorage.getItem('LoginToken') != null){
           this.loginBoolean = true 
           this.citizenHandle = localStorage.getItem('citizenHandle')
           this.citizenName = localStorage.getItem('citizenName')
           this.fetchProfile();
        }
        this.getCountryCodes();

        this.$root.$on('openLoginModal',() =>{
                const el = document.getElementById('loginBtn')
                el.click();
            })
  },
  methods : {
       geolocate() {
        navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          
        };
        this.getGeoAddress();
       this.panToMarker()
        
      });
    },
    getCordinates(){
        axios
                .post('https://entityserver.manikworks.com/bookmgr',null,{
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'FETCH.ONE.OUTLET',
                        'OutletHandle': sessionStorage.getItem('handle'),
                        'BookDS': 'BOOKING2',
                        'Channel': 'WEB',
                        'Latitude': '32',
                        'Longitude': '12',
                        'CountryID': '100000',
                        'CitizenHandle': 'aaa-asasa'
                    }
                })
                .then((response) =>{
                if(response.data.ManikJSon[0].JSon0[0].Latitude != '' && response.data.ManikJSon[0].JSon0[0].Latitude != null){
                    this.markerStore.position.lat = Number(response.data.ManikJSon[0].JSon0[0].Latitude)
                    this.markerStore.position.lng = Number(response.data.ManikJSon[0].JSon0[0].Longitude)
                    this.center.lat = Number(response.data.ManikJSon[0].JSon0[0].Latitude)
                    this.center.lng = Number(response.data.ManikJSon[0].JSon0[0].Longitude)

                    this.geolocate()
                }
                
            })
    },
     handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },
    panToMarker() {
      this.$refs.mapRef.panTo(this.markerStore.position);
    },
    openWhatsapp: function(number){
            window.open('//api.whatsapp.com/send?phone='+number)
        },
    call: function(number){
            window.open('tel:' + number)
    },
    getGeoAddress: function(){
        axios
                .get('https://maps.googleapis.com/maps/api/geocode/json',
                {
                params:{
                    'latlng' : this.marker.position.lat + "," + this.marker.position.lng,
                    'key':'AIzaSyCRNkCEhDvjxASZD11b_PRPZ45VVNdNQZ0'
                }
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                    }
                })
                .then((response) =>{
                console.log(response)
                this.formattedAddress = response.data.results[3].formatted_address
            })
            .catch(() =>{
                
                })
    },
    getCountryDetails: function(event){
        
        this.countryCode = event.target.value
        for(var i=0;i<this.countryList.length;i++){
            if(this.countryList[i].CountryCode == this.countryCode){
                this.phoneMaxLength = this.countryList[i].MobileNumberLength
                this.portalContext = this.countryList[i].CountryDBContext
            }
        }
        
    },
    openTC: function(){
        window.open('https://instaciti.com/terms-conditions/')
    },
    openRefund: function(){
        window.open('https://instaciti.com/refund-cancellation/')
    },
    openReport: function(){
        window.open('https://forms.gle/naiiZFQZ9bd6KbveA')
    },
    logout: function(){
        sessionStorage.removeItem('LoginToken')
        this.loginBoolean = false
        this.componentKey += 1;
    },
    getCountryCodes: function(){
         axios
                .post('https://entityserver.manikworks.com/apputils',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Context':'GET.COUNTRY.AND.LANGUAGE',
                        'Content-Type':'application/json',
                    }
                })
                .then((response) =>{
                    console.log(response)
                    this.countryList = response.data.ManikJSon[0].JSon0
                    this.countryCode = this.countryList[0].CountryCode
                    this.phoneMaxLength = this.countryList[0].MobileNumberLength
                    this.portalContext = this.countryList[0].CountryDBContext
            })
            .catch(() =>{
                
                })
    },
    validatePhone: function(event){
        const mailRegex = /^[0-9]+$/;
            if(!mailRegex.test(event.target.value)){
                 this.phoneErrorMessage = "Please enter valid phone number"
                    return;
            }
            else{
                this.phoneErrorMessage= "";
            }

        if(event.target.value.length != this.phoneMaxLength){
                this.phoneErrorMessage = "Please enter valid phone number"
        }
        else{
            this.phoneErrorMessage = ""
        }
    },
    submitOtp: function(){
            this.userContactNo = document.getElementById('contact').value;
            this.verifyOtpBoolean = false
            const mailRegex = /^[0-9]+$/;
            if(!mailRegex.test(this.userContactNo)){
                console.log(this.userContactNo)
                 this.phoneErrorMessage = "Please enter valid phone number"
                    return;
            }
            else{
                this.phoneErrorMessage= "";
            }

            if(this.userContactNo.length != this.phoneMaxLength){
                this.phoneErrorMessage = "Please enter valid phone number"
                return
                }
            else{
            this.phoneErrorMessage = ""
            }
            this.verifyOtpBoolean = true
            this.phoneErrorMessage =""
            this.isLoading = true
            let items = [
            {
            "CountryCode": this.countryCode,
             "MobileNumber": this.userContactNo,
             "LanguageID": "100000",
             "CountryID": "100000"
            }
        ]
            

                  axios
                .post('https://entityserver.manikworks.com/citizenship',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'LOGIN.BY.MOBILE',
                        'Content-Type': 'application/json',
                        'AuthChannel': 'M',
                        'SignUpSource': 'A',
                        'PortalContext': this.portalContext,
                    }
                })
                .then((response) =>{
                this.otpHandle = response.data.ManikJSon[0].JSon0[0].OTPHandle
                this.citizenHandle = response.data.ManikJSon[0].JSon1[0].CitizenHandle
                var closePhone = document.getElementById("phoneLogin")
                closePhone.click()
                if(response.data.ManikJSon[0].JSon1[0].Status == 'EXISTS'){
                this.citizenName = response.data.ManikJSon[0].JSon1[0].CitizenName
                console.log(this.citizenHandle)
                }
                this.isLoading = false
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },
        updateName: function(){
            if(document.getElementById('username').value == ''){
                this.NameErrorMessage = "Name is mandatory"
                return;
            }
            this.isLoading = true
             let items = [
            {
            "CitizenName": document.getElementById('username').value,
             "CitizenHandle": this.citizenHandle
            }
        ]
                  axios
                .post('https://entityserver.manikworks.com/citizenship',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'UPDATE.NAME',
                        'Content-Type': 'application/json',
                        'PortalContext': this.portalContext,
                    }
                })
                .then((response) =>{
                    console.log(response)
                this.citizenName = document.getElementById('username').value
                const el = document.getElementById('closeName')
                el.click()
                this.isLoading = false
                this.BuyerManagement();
                this.fetchProfile();
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },
        validateOtp: function(){
             if((document.getElementById('otp-1').value).length != 4){
                 this.OtpErrorMessage = "Please enter valid Otp"
                 return
             }
             else{
                 this.OtpErrorMessage = ""
             }
        },
        validateName: function(event){
            if(event.target.value == ''){
                 this.NameErrorMessage = "Name is mandatory"
            }
            else{
                 this.NameErrorMessage = ""
            }
        },
        openUserProfile: function(){
        window.open('http://eol.instaciti.com/profile/' + localStorage.getItem('citizenHandle'))
        },
        resendOtp: function(){
        this.resend = true;
        document.getElementById('otp-1').value = '';
       

        if(this.countdown > 0){
            setTimeout(() => {
                this.countdown -=1
                this.resendOtp();
            },1000)
        }
        else{
            this.countdown = 10;
            this.resend = false;
        }
    },
     verifyOtp: function(){
            if((document.getElementById('otp-1').value).length != 4){
                 this.OtpErrorMessage = "Please enter valid Otp"
                 return
             }
             else{
                 this.OtpErrorMessage = ""
             }
            
                  axios
                .post('https://entityserver.manikworks.com/citizenship',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'VERIFY.OTP',
                        'OTPHandle': this.otpHandle,
                        'EnteredOTP': document.getElementById('otp-1').value,
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>{
                    console.log(response)
                    this.loginBoolean = true
                    this.successfullLogin = true
                    if(this.citizenHandle == this.userContactNo){
                        this.citizenHandle = response.data.ManikJSon[0].JSon1[0].CitizenHandle
                    }

                localStorage.setItem('LoginToken',response.data.ManikJSon[0].JSon0[0].JWT)
                localStorage.setItem('citizenHandle',this.citizenHandle)
                sessionStorage.setItem('Token',response.data.ManikJSon[0].JSon0[0].JWT)
                if(response.data.ManikJSon[0].JSon2[0].Name == "INCOMPLETE"){
                    var closePhone = document.getElementById("phoneLogin")
                    closePhone.click()
                    var closeOtp = document.getElementById("otpClose")
                    closeOtp.click()
                    var openModel = document.getElementById('verifyOtp')
                    openModel.setAttribute('data-toggle','modal')
                    openModel.setAttribute('data-target','#login-name')
                    openModel.click();
                    
                }
                else if(response.data.ManikJSon[0].JSon2[0].Name == "COMPLETE"){
                    
                    var closePhoneComp = document.getElementById("phoneLogin")
                    closePhoneComp.click()
                    var closeOtpComp = document.getElementById("otpClose")
                    closeOtpComp.click()
                    var openModelComp = document.getElementById('verifyOtp')
                    openModelComp.removeAttribute('data-toggle')
                    openModelComp.removeAttribute('data-target')
                    openModelComp.click();
                    this.BuyerManagement();
                }
                this.fetchProfile();
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },
        fetchProfile: function(){

        let items = [
            {
            'CitizenHandle':this.citizenHandle
            }
        ]

        axios
                .post('https://entityserver.manikworks.com/citizenship',
                 {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation':'GET.PROFILE',
                        'Content-Type':'application/json',
                    }
                })
                .then((response) =>{
                   console.log(response)
                   this.successfullLogin = true
                   this.citizenName = response.data.ManikJSon[0].JSon0[0].CitizenName
                   this.userContactNo = response.data.ManikJSon[0].JSon0[0].MobileNumber
                   this.MobileNumberLength = response.data.ManikJSon[0].JSon0[0].MobileNumberLength
                   this.UserImgUrl = response.data.ManikJSon[0].JSon0[0].ImageURL
                   this.$root.$emit('loginBoolean',this.citizenName,this.UserImgUrl)
                   localStorage.setItem('citizenName',this.citizenName)
            })
            .catch(() =>{
                
                })
    },
  }
  
}
</script>

<style>

</style>
